import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VDataTable,{staticClass:"primary",attrs:{"color":"primary","dense":"","headers":_vm.headers,"items":_vm.tags,"items-per-page":30,"hide-default-header":"","hide-default-footer":"","disable-pagination":"","group-by":"point"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }